import { NA } from 'modules/experiments/constants';
import { CellAlignTypes, ExperimentSummaryRowDataProps } from 'modules/experiments/types';
import { calculateConfidence } from 'modules/experiments/utils';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { RowCell } from './RowCell';

export const ConfidenceCell = ({ row }: ExperimentSummaryRowDataProps) => {
  const { t } = useExperimentsTranslations();

  const isMetricsAvailableForCalculations =
    row.sends &&
    row.experimentWinningCriteria &&
    row.controlExperimentSends &&
    row.controlExperimentWinningCriteria;

  if (!isMetricsAvailableForCalculations) {
    return (
      <RowCell
        isWinner={row.winner.toString()}
        dataTestId={`confidence-cell-na-${row.variantTemplateID}`}
        primaryText={NA}
        align={CellAlignTypes.flexEnd}
      />
    );
  }

  if (row.control) {
    return (
      <RowCell
        isWinner={row.winner.toString()}
        dataTestId={`confidence-cell-control-${row.variantTemplateID}`}
        primaryText={t('variantTable.cell.baseline')}
        greyOutContent={true}
        align={CellAlignTypes.flexEnd}
      />
    );
  }
  const confidence = calculateConfidence({
    variantSends: row.sends || 0,
    variantExperimentWinningCriteria: row.experimentWinningCriteria,
    controlExperimentSends: row.controlExperimentSends,
    controlExperimentWinningCriteria: row.controlExperimentWinningCriteria,
  });

  const confidenceText = confidence === NA ? confidence : `${confidence.toFixed(2)}%`;

  return (
    <RowCell
      isWinner={row.winner.toString()}
      dataTestId={`confidence-cell-variant-${row.variantTemplateID}`}
      primaryText={confidenceText}
      align={CellAlignTypes.flexEnd}
    />
  );
};
